import React from 'react'
import { useTranslation } from 'react-i18next'
import { StatisticsDashboard } from '@cbgms/api/modules/statistics'
import GenericMonitorChart from './GenericMonitorChart'

const MonitorShopsChart: React.FC<{ data: StatisticsDashboard[] }> = props => {
  const { t } = useTranslation()

  return <GenericMonitorChart data={props.data} title={t('global.stats.shops')} dataSelector={row => row.TotalShops} />
}

export default MonitorShopsChart
